module.exports = __webpack_public_path__ + "img/mm.a0ec2a94.svg";